var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"label-style",style:({width: `${_vm.size}px`, height: `${_vm.size}px`, backgroundColor: _vm.color})})
}
var staticRenderFns = []

export { render, staticRenderFns }